<template>
  <div class="welcome-container">
    <div>
      <div class="h1"> WELCOME {{ username }} TO</div>
      <div class="h1"><img class="logo" src="../../assets/img/newerp_icon3.png" alt="" />全球青少年PBL创新素养大会</div>
      <!-- <img class="logo" src="../../assets/img/newerp_button3.png" /> -->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: window.sessionStorage.getItem('username')
    }
  }
}
</script>
<style scoped lang="less">
.welcome-container{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.welcome-container>div{
  width: 60%;
}
.logo{
  width: 100%;
}
.h1 {
  font-weight: 600;
  font-size: 32px;
  color: #231816;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  .logo{
    width: 60px;
    height: 60px;
    margin-right: 10px;
  }
}
</style>
